import { render } from "./globalFilter.vue?vue&type=template&id=ef56a884&scoped=true"
import script from "./globalFilter.vue?vue&type=script&lang=js"
export * from "./globalFilter.vue?vue&type=script&lang=js"

import "./globalFilter.vue?vue&type=style&index=0&id=ef56a884&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef56a884"]])

export default __exports__